
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround2Off as ObiGround2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-2-off.js';
 
 
 

 
 export const ObiGround2Off = createComponent({
   react: React,
   tagName: 'obi-ground-2-off',
   elementClass: ObiGround2OffElement,
   events: {
     
   }
  });
 
 